// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__fJNi2","modalFooterButton":"ModalNotes_modalFooterButton__2bMn9"};